module.exports = __webpack_public_path__ + "img/CARE_CALENDAR.f9acb3b0.svg";